import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuickMenuComponent } from './quick-menu.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
const COMPONENTS = [QuickMenuComponent];

@NgModule({
  imports: [CommonModule, NgZorroAntdModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class AdQuickMenuModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: AdQuickMenuModule, providers: [] };
  }
}
